module.exports = __webpack_public_path__ + "img/student_help_virtual.6039fa33.jpg";